import React from 'react';
import { motion } from 'framer-motion';

const Card = ({ children, className = '', ...props }) => {
    return (
        <motion.div
            whileHover={{ y: -5 }}
            className={`bg-white rounded-lg shadow-md overflow-hidden border border-slate-200 hover:shadow-xl transition-shadow duration-300 ${className}`}
            {...props}
        >
            {children}
        </motion.div>
    );
};

export default Card;
